import { MEASUREMENT_UNIT } from './common.model'

export enum GENERATE_OTP_FLOW {
  ONBOARDING = 1,
  UPDATE_PROFILE = 2,
  LOGIN = 3,
  UPDATE_PROFILE_WITHOUT_LOGIN = 4,
  MANUAL_REGISTER = 5,
}

export enum VERIFY_OTP_TYPE {
  PHONE_NUMBER,
  EMAIL,
  SP_UTILITY,
}

export interface IAuth {
  id: string
  name: string
  lastLogin: string
  isNewUser: boolean
  preferredWaterMeasurement: MEASUREMENT_UNIT
  receivePublicityMaterials: boolean
}

export interface IAuthCallbackSingpass {
  encryptedNric: string
  hashedNric: string
  hashedLast4Nric: string
  hashedUen?: string
  hashedLast4Uen?: string
  checksum?: string
  isExist: boolean
}

export interface IMyInfo {
  name: string
  mobileNumber: string
  message: string
  emailAddress: string
  residentialAddress?: {
    block: string
    postal: string
    unit: string
  }
}

export interface IAuthAcceptedCredentials {
  hashedNric?: string
  hashedLast4Nric?: string
  hashedUen?: string
}

export interface IManualRegisterAuthOption {
  email: string
  phoneNumber: string // last 4 numbers
}
